import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {IGenericKeyValue} from "../../../storage/interfaces/generic.interface";

@Component({
    selector: 'app-chip-status[status]',
    templateUrl: './chip-status.component.html',
    styleUrls: ['./chip-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChipStatusComponent {

  @Input() status: IGenericKeyValue = {key: 'UNSET', value: 'Not set'};

  constructor() { }

}
